import { Box, BoxProps } from 'grommet';
import { PropsWithChildren, useState } from 'react';

export interface IBlinkProps extends PropsWithChildren {
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  enabled?: boolean;
  disabled?: boolean;
  speed?: number;
  boxProps?: BoxProps;
}

export const Blink = ({ children, size = 'large', enabled = true, disabled = false, speed, boxProps }: IBlinkProps) => {
  const [isVisible, setIsVisible] = useState(true);

  const shouldBlink = enabled === true && disabled === false;

  return (
    <Box
      animation={shouldBlink ? { type: isVisible ? 'fadeOut' : 'fadeIn', size, duration: speed } : undefined}
      onAnimationEnd={shouldBlink ? () => setIsVisible(!isVisible) : undefined}
      {...boxProps}
    >
      {children}
    </Box>
  );
};
